export default "__VITE_ASSET__gDYaoAWF__"